import { Component, OnInit, ElementRef, Input, PLATFORM_ID, Inject, NgZone, HostListener, Renderer2, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { IPlayable, IMediaSubscriptions } from 'videogular2/src/core/vg-media/i-playable';
import { VgStates, VgEvents, VgAPI } from 'videogular2/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, MediaStream } from 'angular-engine/modules/ng-express-engine/tokens';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';

declare let chrome;
declare let cast;

@Component({
  selector: 'vg-chromecast',
  templateUrl: './vg-chromecast.media.component.html',
  styleUrls: ['./vg-chromecast.media.style.scss']
})
export class VgChromecastMedia implements IPlayable {

  private isChrome: boolean = false;
  private canCast: boolean = false;
  public isCasting: boolean = false;
  private attemptCasting: boolean = false;
  private primaryMedia: any;
  //private chromeCastMedia: any;
  private isRegistered: boolean = true;
  private previousSession: boolean = false;
  private sessionEnded = false;
  private connectionAttempts = 10;
  private reinitTries = 5;
  private startSubscription: Subscription;
  private remoteCastingStarted = false;
  id: string = 'vgChromecastMedia';
  elem: any;
  time: any = { current: 0, total: 0, left: 0 };
  buffer: any;
  track?: any;
  canPlay: boolean = false;
  canPlayThrough: boolean = false;
  isMetadataLoaded: boolean = false;
  isWaiting: boolean = false;
  isCompleted: boolean = false;
  isLive: boolean = false;
  state: string;// = VgStates.VG_PAUSED;
  internal_state = '';
  is_paused: boolean = false;
  internal_position: number = -1;
  internal_volume: number = 1;
  textTracks: TextTrackList;
  subscriptions: IMediaSubscriptions = <IMediaSubscriptions>{};
  _duration: number;
  _currentTime: number = -1;
  timer: any;
  @Input() vgMaster: boolean;
  @Input() vgSkipSync: boolean = false;
  @Input() vgMedia: any;
  @Input() src: string;
  @Input() autoplay: boolean;
  @Input() poster: any;
  @Input() dataDuration: number;
  @Input() meta: any;
  posterVisible: boolean = true;
  isClient: boolean = false;
  internal_buffered: Object = {
    length: 1,
    internal_end: 1,
    internal_start: 0,
    start: function (index) {
      return this.internal_start;
    },
    end: function (index) {
      return this.internal_end;
    }
  };

  mediaInfo: any;
  apiMedia: any;
  castSession: any;
  castContext: any;


  constructor(
    private ref: ElementRef,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
    @Inject(APP_SETTINGS) private settings: Object,
    protected coreEffects: CoreEffects,
    private cd: ChangeDetectorRef,
    private api: VgAPI,
    private interactions: EventInteraction
  ) {
    this.isClient = isPlatformBrowser(this.platformId);
    this.elem = ref.nativeElement;
    this.id = this.elem.id;
    if (this.isClient) {
      //this.elem = document.getElementById('singleVideo');
      this.id = 'vgChromecastMedia';
      this.isChrome = this.deviceInfo.userAgent.toLowerCase().indexOf("chrome") > -1;
      if (this.isChrome){
        this.startSubscription = this.interactions.subscribe(e => {
          if (e.key == "startCasting") {
            if(e.message.startCasting){
              //console.log("vp asked for cast");
              this.isCasting = false;
              if (!this.remoteCastingStarted){
                //console.log("remote casting flag not set");
                this.remoteCastingStarted = true;
                //console.log("starting casting");
                this.toggleCasting();
              }
              else{
                //console.log("resetting the remote casting flag");
                this.remoteCastingStarted = false;
              }
            }
          }
        });
      }
    }
  }

  ngOnInit() {
    this.getCastContext();
  }

  ngAfterViewInit() {
    if (!this.castContext) {
      if (this.reinitTries > 0) {
        this.reinitTries -= 1;
        setTimeout(this.ngAfterViewInit.bind(this), 300);
        return;
      }
    }
    const stateCastingState = this.coreEffects.getInternalStateValue('isChromeCast');
    if (stateCastingState) {
      //this.toggleCasting();
    }
    else {
      if (this.previousSession) {
        this.previousSession = false;
        this.coreEffects.setInternalStateValue('isChromeCast', true);
        if (!this.primaryMedia) {
          this.primaryMedia = this.api.getMediaById('singleVideo');
        }
        if (this.primaryMedia) {
          this.primaryMedia.pause();
        }
        //this.toggleCasting();
      }
    }
  }

  private getCastContext() {
    try {
      this.castContext = cast.framework.CastContext.getInstance();
    }
    catch (oops) { 
      //console.log("get cast context error");
    }
    if (this.castContext) {
      //console.log("cast context found");
      this.castContext.addEventListener(cast.framework.CastContextEventType.SESSION_STATE_CHANGED, this.sessionStateChanged);
      if (!chrome.cast || !chrome.cast.isAvailable) {
        //console.log("should not hit this ever");
        this.initializeCastApi();
      }
      else{
        //console.log("checking for previous session...");
        this.onInitSuccess();
      }
    }
    else if (this.connectionAttempts > 0) {
      this.connectionAttempts -= 1;
      setTimeout(this.getCastContext.bind(this), 200);
      return;
    }
  }

  sessionStateChanged = (event) => {
    switch (event.sessionState) {
      case cast.framework.SessionState.SESSION_STARTED:
      if (!this.isCasting) {
        //this.isCasting = true;
        //this.interactions.next({ key: "castingChange", message: { activeMedia: "vgChromecastMedia" } });
        this.toggleCasting();
      }
      break;
      case cast.framework.SessionState.SESSION_RESUMED:
        if (!this.isCasting) {
          //this.isCasting = true;
          //this.interactions.next({ key: "castingChange", message: { activeMedia: "vgChromecastMedia" } });
          //console.log("asking vp to cast");
          this.interactions.next({ key: "needsCasting", message: { needsCasting: true } });
          //this.toggleCasting();
        }
        break;
      case cast.framework.SessionState.SESSION_ENDING:
        this.removeListeners();
        break;        
      case cast.framework.SessionState.SESSION_ENDED:
        this.sessionEnded = true;
        this.onCastStopSuccessComplete();
        break;
      case cast.framework.SessionState.SESSION_START_FAILED:
        this.isCasting = false;
        this.attemptCasting = false;
        this.coreEffects.setInternalStateValue('isChromeCast', false);
        this.interactions.next({ key: "castingChange", message: { activeMedia: "singleVideo" } });
        return false;
    }
  }

  public initializeCastApi() {
    //console.log(chrome);
    if (typeof chrome != 'undefined' && (!chrome.cast || !chrome.cast.isAvailable)) {
      setTimeout(this.initializeCastApi.bind(this), 200);
      return;
    }
    if (1 == 1) {
      let options = {};
      var apiConfig, appId, sessionRequest;
      appId = this.settings['CHROMECAST_RECEIVER_ID'];

      cast.framework.CastContext.getInstance().setOptions({
        receiverApplicationId: appId,
        autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED
      });
      this.onInitSuccess();
    }
    else { }
    //this.chromeCastInited = true;        
  }

  onInitSuccess() {
    this.previousSession = (this.castContext.getCurrentSession()) ? true : false;
  }

  toggleCasting() {
    if (this.isCasting) {
      this.stopCasting();
    }
    else {
      //this.isCasting = true;
      if(!this.attemptCasting)
      {
        this.createSession();
        this.coreEffects.setInternalStateValue('isChromeCast', true);
        this.attemptCasting = true;
      }
      
    }
  }

  public createSession() {
    if (this.castContext) {
      //console.log("cast context found");
      const session = cast.framework.CastContext.getInstance().getCurrentSession();
      if (session == null) {
        //console.log("creating new session");
        cast.framework.CastContext.getInstance().requestSession().then(() => {
          this.isCasting = true;
          this.onSessionSuccess(cast.framework.CastContext.getInstance().getCurrentSession());
        }, (e) => {
          //console.log("no devices found");
          this.attemptCasting = false;
          this.coreEffects.setInternalStateValue('isChromeCast', false);
          //console.log(e);
        })
      }
      else {
        //console.log("session found");
        this.isCasting = true;
        this.onSessionSuccess(cast.framework.CastContext.getInstance().getCurrentSession());
      }
    }
    else {
      
    }
  }

  private onSessionSuccess = function (session) {
    var image, key, loadRequest, mediaInfo, value, _ref;
    
    this.castSession = session;
    this.castSession.addEventListener(cast.framework.SessionEventType.MEDIA_SESSION, this.onMediaDiscovered)
    //console.log("loading");
    this.load();
  }

  onMediaDiscovered = (media) => {
    
    if(this.apiMedia)
    {
      this.apiMedia.removeUpdateListener(this.onMediaStatusUpdate);
    }
    this.apiMedia = media.mediaSession;
    this.apiMedia.addUpdateListener(this.onMediaStatusUpdate);
    if(this.isCompleted)
    {
      this.currentTime = 0;
    }
    this.isCasting = true;
    this.pausePrimaryMedia();
    this.dispatchStartEvents();
    this.interactions.next({ key: "castingChange", message: { activeMedia: "vgChromecastMedia" } });
    this.state = VgStates.VG_PLAYING;
    this.setupBuffer();
    this.dipatchPlayingEvents();
    this.isCompleted = false;
    this.cd.detectChanges();
  }

  onMediaStatusUpdate = (isAlive) => {
    if (!this.apiMedia) {
      return;
    }
    
    var cCastTime = this.apiMedia.getEstimatedTime();
    if (!this.isCompleted && this.apiMedia.playerState == chrome.cast.media.PlayerState.IDLE && this.apiMedia.idleReason == chrome.cast.media.IdleReason.FINISHED) {
      this.isCompleted = true;
      this.clearTimer();
      this.primaryMedia.currentTime = this._duration;
      this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
      this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
      cCastTime = 0
    }
    else {
      if(this.apiMedia.playerState == chrome.cast.media.PlayerState.IDLE && this.apiMedia.idleReason !== chrome.cast.media.IdleReason.FINISHED)
      {
        this.clearTimer();
      }
    }
    //this.primaryMedia.currentTime = cCastTime
    this._currentTime = cCastTime;
    //this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
  }

  private load() {
    if (!this.primaryMedia) {
      this.primaryMedia = this.api.getMediaById('singleVideo');
    }
    if (!this.primaryMedia) {
      setTimeout(this.load.bind(this), 100);
      return;
    }
    
    if(this.meta.obj_type == "Stream")
    {
      this._duration = null;
    }
    else{
      this._duration = this.meta.duration || this.meta.video.meta.duration;
    }

    if (!this._duration) {
      this._duration = this.primaryMedia.duration;
    }
    
    this.setMediaInfo();
    const loadRequest = new chrome.cast.media.LoadRequest(this.mediaInfo);
    this.primaryMedia['playAfterSync'] = true;
    this._currentTime = this.primaryMedia.currentTime;
    if (this.isCompleted){
      this._currentTime = 0;
    }
    loadRequest.currentTime = this._currentTime;

    this.castSession.loadMedia(loadRequest).then((e) => {
      if (e != null) {
        //todo: error condition
      }
      //this.onMediaDiscovered()
    })
    this.cd.detectChanges();
  }

  private setMediaInfo() {
    this.mediaInfo = new chrome.cast.media.MediaInfo(this.src + "?time=" + Date.now(), "video");
    this.mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
    if (this.meta) {
      if (this.meta.obj_type == "Episode") {
        this.mediaInfo.metadata = new chrome.cast.media.TvShowMediaMetadata();
        this.mediaInfo.metadata.seriesTitle = this.meta.series ? this.meta.series.title : "";
        this.mediaInfo.metadata.episode = this.meta.number;
        this.mediaInfo.metadata.season = this.meta.season.number;
      }
      this.mediaInfo.metadata.title = this.meta ? this.meta.title : this.settings['WEBSITE_TITLE'];
      this.mediaInfo.metadata.subtitle = this.meta.sub_head;
    }
    if (this.poster) {
      const image = new chrome.cast.Image(this.poster);
      this.mediaInfo.metadata.images = [image];
    }
  }

  private stopCasting() {
    //this.setPrimaryMediaOnStopCasting();
    this.castSession.endSession(true);
    //this.clearTimer();
    //this.onCastStopSuccess();
  }

  private setPrimaryMediaOnStopCasting() {
    if (this.isCompleted) {
      this._currentTime = 0;
    }
    else if (!this.sessionEnded && this.apiMedia) {
      this._currentTime = this.apiMedia.getEstimatedTime();
    }
    else {
      this.sessionEnded = false;
    }
    if(this.meta.obj_type !== "Stream")
    {
      this.primaryMedia.currentTime = this._currentTime;
    }
    
    //this.api.registerMedia(this.primaryMedia);
    if (!this.isCompleted) {
      this.interactions.next({ key: "autoplay", message: { autoplay: true } });
//       this.primaryMedia.play();
//       this.primaryMedia.state = VgStates.VG_PLAYING;
    }
    else {
      this.interactions.next({ key: "autoplay", message: { autoplay: false } });
    }
  }

  private clearTimer() {
    if (this.timer) {
      try {
        clearInterval(this.timer);
      }
      catch (e) { }
      this.timer = null;
    }
  }

  private removeListeners(){
    if (this.apiMedia) {
      //console.log("removing media status update listener");
      this.apiMedia.removeUpdateListener(this.onMediaStatusUpdate);
      //this.apiMedia = null;
    }
    if (this.castSession) {
      //console.log("removing media session listener");
      this.castSession.removeEventListener(cast.framework.SessionEventType.MEDIA_SESSION, this.onMediaDiscovered);
    }
  }

  private onCastStopSuccessLight() {
    if (this.apiMedia) {
//       console.log("removing media status update listener");
//       this.apiMedia.removeUpdateListener(this.onMediaStatusUpdate);
      this.apiMedia = null;
    }
    this.attemptCasting = false;
    this.isCasting = false;
    this.state = VgStates.VG_PAUSED;
    this.interactions.next({ key: "castingChange", message: { activeMedia: "singleVideo" } });
    //this.coreEffects.setInternalStateValue('isChromeCast', false);
    this.isRegistered = false;
  }

  private onCastStopSuccess() {
    if (this.apiMedia) {
//       this.apiMedia.removeUpdateListener(this.onMediaStatusUpdate);
      this.apiMedia = null;
    }
    this.attemptCasting = false;
    this.isCasting = false;
    this.state = VgStates.VG_PAUSED;
    this.interactions.next({ key: "castingChange", message: { activeMedia: "singleVideo" } });
    this.coreEffects.setInternalStateValue('isChromeCast', false);
    this.isRegistered = false;
  }

  private onCastStopSuccessComplete() {
    this.setPrimaryMediaOnStopCasting();
    this.clearTimer();
    this.onCastStopSuccess();
  }

  private dispatchStartEvents() {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOAD_START));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_METADATA));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_CAN_PLAY));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_DATA));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOAD_START));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_METADATA));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_CAN_PLAY));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_DATA));
  }

  private dipatchPlayingEvents() {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_DURATION_CHANGE));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PROGRESS));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAY));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_DURATION_CHANGE));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PROGRESS));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAY));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));
    this.startProgressTimer(this.incrementMediaTime.bind(this));
  }

  private pausePrimaryMedia() {
    this.primaryMedia.pause();
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PAUSE));
    this.primaryMedia.state = VgStates.VG_PAUSED;
  }

  private setupBuffer() {
    this.internal_buffered['internal_start'] = (this._currentTime < 5) ? 0 : (this._currentTime - 5);
    if ((this._currentTime + 10) > this._duration) {
      this.internal_buffered['internal_end'] = this._duration;
    }
    else {
      this.internal_buffered['internal_end'] = this._currentTime + 10;
    }
  }

  private incrementMediaTime = function () {
    if (!this.apiMedia) {
      return;
    }
    if (!this.isCasting){
      this.isCasting = true;
    }
    if (this.apiMedia.playerState !== chrome.cast.media.PlayerState.PLAYING) {
      return;
    }
    if (this._currentTime <= this._duration) {
      this._currentTime += 1;
      this.setupBuffer();
      //this.primaryMedia.currentTime += 1;
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PROGRESS));
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
      this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PROGRESS));
      this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
    } else {
      this.clearTimer();
    }
  };

  private startProgressTimer = function (callback) {
    this.clearTimer();
    this.timer = setInterval(callback.bind(this), 1000);
  };

  private checkConnected() {
    const connected = arguments[0];
    if (connected == true || connected == 'true') {
      this.canCast = true;
    }
    else {
      this.canCast = false;
    }
  }

  private onSeekSuccess(pos) {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKED));
    this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKED));
  }

  get buffered() {
    return this.internal_buffered;
  }

  set currentTime(seconds) {
    this.seekTime(seconds);
    //this._currentTime = seconds;
  }

  get currentTime() {
    return this._currentTime;
  }

  get duration() {
    return this._duration;
  }

  set volume(volume) {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_VOLUME_CHANGE));
    if (!this.apiMedia) {
      return;
    }
    let cVolume: any = new chrome.cast.Volume();
    cVolume.level = volume;
    cVolume.muted = false;
    this.internal_volume = volume;
    let request = new chrome.cast.media.VolumeRequest();
    request.volume = cVolume;
    this.apiMedia.setVolume(request, this.onCastSuccess.bind(this, 'Volume changed'), this.onSessionError.bind(this));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_VOLUME_CHANGE));
  }

  get volume() {
    return this.internal_volume;
  }

  play() {
    if (this.apiMedia) {
      if (this.isCasting && this.isCompleted) {
        if(!this.castSession.getMediaSession())
        {
          this.load();
        }
        else
        {
          this.seekTime(0);
          this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAY));
          this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));
          this.apiMedia.play(null, this.onCastSuccess.bind(this, 'Playing'), this.onSessionError.bind(this));
        }
        return;
      }
      else
      {
        this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAY));
        this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));
        this.apiMedia.play(null, this.onCastSuccess.bind(this, 'Playing'), this.onSessionError.bind(this));
      }
      
    }
  }

  pause() {
    if (this.apiMedia) {
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PAUSE));
      this.apiMedia.pause(null, this.onCastSuccess.bind(this, 'Paused'), this.onSessionError.bind(this));
    }
  }

  seekTime(value: number, byPercent: boolean = false) {
    if (this.apiMedia) {
      let pos: number;
      let duration: number = this._duration;

      if (byPercent) {
        pos = value * duration / 100;
      }
      else {
        pos = value;
      }
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKING));
      this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKING));
      let request = new chrome.cast.media.SeekRequest();
      request.currentTime = pos;
      request.resumeState = chrome.cast.media.ResumeState.PLAYBACK_START;
      this.apiMedia.seek(request, this.onSeekSuccess.bind(this, pos), this.onSessionError.bind(this));
    }
  }

  private onSessionError() {
    const e: any = arguments[0];
    //console.log("green eggs and ham");
    console.log(e);
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ERROR));
    
  }

  private onCastSuccess() {
    const e: any = arguments[0];
    
    if (e.toLowerCase() == "playing") {
      this.state = VgStates.VG_PLAYING;
    }
    if (e.toLowerCase() == "pause") {
      this.state = VgStates.VG_PAUSED;
    }
  }

  ngOnDestroy() {
    if (this.isCasting){
      this.setPrimaryMediaOnStopCasting();
      this.clearTimer();
      this.onCastStopSuccessLight();
    }
//     this.clearTimer();
//     if (this.apiMedia) {
//       this.apiMedia.removeUpdateListener(this.onMediaStatusUpdate);
//     }
    if (this.castSession) {
      //console.log("removing media session listener");
      this.castSession.removeEventListener(cast.framework.SessionEventType.MEDIA_SESSION, this.onMediaDiscovered)
    }
    if (this.startSubscription) {
      this.startSubscription.unsubscribe();
      this.startSubscription = null;
    }
    if (this.primaryMedia){
      if (this.primaryMedia.state != VgStates.VG_ENDED){
        this.primaryMedia.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
        this.primaryMedia.state = VgStates.VG_ENDED;
        try{
          this.api.unregisterMedia(this.primaryMedia);
        }
        catch(e){}
        delete this.primaryMedia.elem;
        //this.primaryMedia = null;
      }
    }
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
    this.state = VgStates.VG_ENDED;

    //this.api.unregisterMedia(this);

    if (this.api){
      //this.api.fsAPI.medias.destroy();
      //this.api.getMediaById('vgChromecastMedia').ngOnDestroy();
      //this.primaryMedia.ngOnDestroy();
      this.api.fsAPI.medias = null;
      this.api.medias = {};
    }
    this.internal_buffered = null;
    this.vgMedia = null;
    this.src = null;
    //console.log("removing session state listener");
    this.castContext.removeEventListener(cast.framework.CastContextEventType.SESSION_STATE_CHANGED, this.sessionStateChanged);
    this.apiMedia = null;
    this.primaryMedia = null;
    this.castSession = null;
    this.castContext = null;
    delete this.elem;
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/vg-chromecast/vg-chromecast.media/vg-chromecast.media.component.ts